<template>
	<div class="rt">
		<div class="barMian" ref="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
	</div>
</template>


<script>
import * as methods from './method.js'
export default {
	name: "template.scope34",
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '基本折线堆叠柱状图-scope34',
			timer: null,
			defaultdata: [
				{ value1: '1月', value2: '80', value3: '系列一', value4: '60', value5: '系列二', value6: '60', value7: '系列三' },
				{ value1: '2月', value2: '40', value3: '系列一', value4: '40', value5: '系列二', value6: '30', value7: '系列三' },
				{ value1: '3月', value2: '62', value3: '系列一', value4: '70', value5: '系列二', value6: '70', value7: '系列三' },
				{ value1: '4月', value2: '90', value3: '系列一', value4: '20', value5: '系列二', value6: '50', value7: '系列三' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '柱状图数值1', key: "value2" },
				{ name: '柱状图图例1', key: 'value3' },
				{ name: '柱状图数值2', key: "value4" },
				{ name: '柱状图图例2', key: 'value5' },
				{ name: '折线图数值', key: "value6" },
				{ name: '折线图图例', key: 'value7' },
				{ name: '单位1', key: 'value8' },
				{ name: '单位2', key: 'value9' },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
		};
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.DrawEcharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null;
			var echarts = require("echarts");
			var TmyChart = echarts.init(this.$refs.barMian);
			let data1 = [];
			let data2 = [];
			let data3 = [];
			let legend = [];
			let unit = this.defaultdata[0].value8 || ''
			let unit2 = this.defaultdata[0].value9 || ''
			this.defaultdata.forEach((item, i) => {
				if (item.value2 && item.value3) {
					const vdata1 = { name: item.value3, value: item.value2 };
					data1.push(vdata1);
				}
				if (item.value4 && item.value5) {
					const vdata2 = { name: item.value5, value: item.value4 };
					data2.push(vdata2);
				}
				if (item.value6 && item.value7) {
					const vdata3 = { name: item.value7, value: item.value6 };
					data3.push(vdata3);
				}
				if (i == 0) {
					if (item.value3) {
						legend.push({
							top: "2%",
							right: "50%",
							itemHeight: 12, //图例的高度  文字左边那个
							itemWidth: 10,
							textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
							data: [{ name: item.value3, icon: "rect" }],
						});
					}
					if (item.value5) {
						legend.push({
							top: "2%",
							left: "50%",
							itemHeight: 12, //图例的高度  文字左边那个
							itemWidth: 10,
							textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
							data: [{ name: item.value5, icon: "rect" }],
						});
					}
					if (item.value7) {
						legend.push({
							top: "2%",
							left: "63%",
							itemWidth: 15,
							itemHeight: 3, //图例的高度  文字左边那个
							textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
							data: [{ name: item.value7 }],
						});
					}
				}
			});
			const xAxis = this.defaultdata.map((item) => {
				return item.value1;
			});
			const percent = (7 / xAxis.length) * 100;
			let zoom = [
				{
					id: "scope34", // 唯一的id
					filterMode: "empty",
					xAxisIndex: [0], //滑动条为竖
					mayValueSpan: 7, // 显示数据的条数(默认显示10个)
					type: "slider",
					showDetail: false, //关闭：拖拽时候显示详细数值信息。
					dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					backgroundColor: "transparent",
					fillerColor: "transparent",
					borderColor: "transparent",
					start: 0,
					end: percent,
					top: "80%",
					height: "5%",
				},
			];
			var Toption = {
				title: [
					{
						text: unit,
						top: "0",
						left: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
					{
						text: unit2,
						top: "0",
						right: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
				],
				tooltip: {
					trigger: "axis",
				},
				grid: {
					left: "5px",
					right: "10px",
					bottom: "0px",
					top: "40px",
					containLabel: true,
				},
				legend: [...legend],
				xAxis: [
					{
						type: "category",
						data: this.defaultdata.map((item) => item.value1),
						splitLine: {
							show: false,
						},
						axisLabel: {
							interval: 0,
							width: 50,
							overflow: 'truncate', //文字超出宽度截断，默认为...
							
							textStyle: {
								color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
								fontSize: "14",
								lineHeight: 16,
							},
							formatter: function (value) {
								return value
							},
						},
						axisLine: {
							lineStyle: {
								// X 轴颜色配置
								color: "#4792e9",
							},
						},
						axisTick: {
							show: false,
						},
						axisPointer: {
							type: "shadow",
						},
					},
				],
				yAxis: [
					{
						type: "value",
						min: 0,
						splitNumber: 4,
						axisLabel: {
							textStyle: {
								color: "#bdc2cb", // 这里将 x 轴文本颜色设为灰白色
							},
							formatter: "{value} ",
						},
						axisLine: {
							show: false,
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: "dashed",
								color: "rgba(231,241,251,.2)",
							},
						},
					},
					{
						type: "value",
						splitNumber: 4,
						max: 100,
						containLabel: true,
						// interval: 5,
						axisLabel: {
							textStyle: {
								color: "#bdc2cb", // 这里将 x 轴文本颜色设为灰白色
							},
							formatter: "{value} ",
						},
						axisLine: {
							show: false,
						},
						splitLine: {
							show: false,
						},
					},
				],
				series: [
					{
						name: this.defaultdata[0].value3,
						type: "bar",
						stack: "total",
						barWidth: 15,
						barGap: "40%",
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0,
											color: "#0182fc", // 0% 处的颜色
										},
										{
											offset: 0.4,
											color: "#0182fc", // 0% 处的颜色
										},
										{
											offset: 0.8,
											color: "#08315f", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						data: data1,
					},
					{
						name: this.defaultdata[0].value5,
						type: "bar",
						stack: "total",
						barWidth: 15,
						barGap: "40%",
						label: {
							normal: {
								show: false,
								position: "top",
								color: "#fff",
							},
							show: true,
						},
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0,
											color: "#00e3e2", // 0% 处的颜色
										},
										{
											offset: 0.6,
											color: "#00e3e2", // 0% 处的颜色
										},
										{
											offset: 0.9,
											color: "#02323d", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						data: data2,
					},
					{
						name: this.defaultdata[0].value7,
						type: "line",
						areaStyle: {},
						yAxisIndex: 1,
						smooth: true,
						// smooth: true,//线条原画
						symbol: "none", //线条点击
						smooth: 0.5,
						// label: {
						// 	show: true,
						// 	position: 'top',
						// 	textStyle: {
						// 		//设置文本样式
						// 		color: "#6FF2FA",
						// 	},
						// 	formatter: '{c} %'
						// },
						lineStyle: {
							color: "#F6680A",
							width: 2,
						},
						itemStyle: {
							normal: {
								// 渐变 color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								color: new echarts.graphic.LinearGradient(
									1,
									1,
									1,
									1,
									[
										{
											offset: 0,
											color: "#F6680A", // 0% 处的颜色
										},
										{
											offset: 0.6,
											color: "#006a5b", // 0% 处的颜色
										},
										{
											offset: 0.9,
											color: "rgba(0, 0, 0, 0.3)", // 半透明的颜色 // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						data: data3,
					},
				],
				dataZoom: xAxis.length > 7 ? zoom : [],
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(() => {
				if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000);
		},
	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		// this.$nextTick(() => {
		this.DrawEcharts(); //需要刷新的数据
		// });
	}
};
</script>

<style scoped lang="scss">
.rt {
	width: 435px;
	height: 240px;
	display: flex;
	position: relative;
	overflow: hidden;
	padding: 10px 0;
}

.barMian {
	width: 100%;
	height: 100%;
}
</style>